import { render, staticRenderFns } from "./BlockType30.vue?vue&type=template&id=46fb890b&scoped=true"
import script from "./BlockType30.vue?vue&type=script&lang=ts"
export * from "./BlockType30.vue?vue&type=script&lang=ts"
import style0 from "./BlockType30.vue?vue&type=style&index=0&id=46fb890b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb890b",
  null
  
)

export default component.exports